// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style_breadcrumbs__h0bO0","path":"style_path__1C210","arrow":"style_arrow__pPMY0"};